module.exports = __webpack_public_path__ + "static/img/CH@2x.2b375f27.jpg";